import { environment } from './environments/environment';
const promptType =['select_account','none','login'];
export const AppMsalConfig = {
  clientId: environment.msalAuth.clientId,
  authority: environment.msalAuth.authority,
  validateAuthority:environment.msalAuth.validateAuthority,
  navigateToLoginRequestUrl: true,
  scopes:environment.msalAuth.scopes,
  cache: {
    cacheLocation: 'localStorage'
  },
  groupId:environment.idenediGroupId,
  accessToken:null,
  prompt: promptType[2],
};
